export default {"src":"https://static.carma.com.au/_next/static/media/IconSuccess.5e083902.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};